var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section section__lk"},[_c('div',{staticClass:"section__wrapper section__subsection-wrapper"},[_c('profile-header'),_c('div',{staticClass:"section__lk-wrapper"},[_c('profile-menu'),_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }